// Hook odpowiedzialny za pobranie danych tiles dla dashboardu handlowca

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

// typ zwracanych danych z backendu
export interface ITraderDashboardTile {
  icon: {
    type: string;
    url: string;
  };
  title: string;
  type: 'text' | 'ratio';
  data: {
    text?: string;
    textAdditional?: string;
    target?: number;
    current?: number;
  };
  info?: string;
  url?: string;
}

export interface IResponse {
  tiles: ITraderDashboardTile[];
}

const getTraderDashboardTiles = (): Promise<IResponse> =>
  axios.get('/sales-crm/dashboard');

export const useGetTraderDashboardTiles = (
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['trader-dashboard-tiles'],
    () => getTraderDashboardTiles(),
    options
  );
